import { render, staticRenderFns } from "./MailTemplateForm.vue?vue&type=template&id=0d6afafc&"
import script from "./MailTemplateForm.vue?vue&type=script&lang=js&"
export * from "./MailTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports